// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__vcNDC","pageButton":"Pagination_pageButton__k-5Gy","active":"Pagination_active__DDld0","ellipsis":"Pagination_ellipsis__dtjnQ"};